export default {
  alertSystemHeader: {
    alertCode: 'Cổ phiếu cảnh báo',
    organCode: 'organCode',
    ticker: 'Mã',
    alertGroup: 'Nhóm cảnh báo',
    createDate: 'Thời gian',
    message: 'Nội dung',
    notificationId: 'Thông báo',
    status: 'Trạng thái',
    title: 'Tiêu đề',
    alertName: 'Cảnh Báo',
  },
  button: {
    save: 'LƯU',
    cancel: 'HỦY',
  },
  titlePopup: {
    setting: 'CÀI ĐẶT',
  },
};
